import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log('[PRODUCTION DEBUG] === BOOT SEQUENCE START ===', {
  timestamp: new Date().toISOString(),
  pathname: location.pathname,
  userAgent: navigator.userAgent,
  buildInfo: import.meta.env.MODE
});

// One-time data migration scripts are disabled to prevent console errors for unauthenticated users
// These scripts have already been executed and their data imported
// To re-enable, remove the early return or clear the respective localStorage flags
if (!location.pathname.startsWith('/app-form')) {
  console.log('[PRODUCTION DEBUG] Skipping data migration imports (already completed)');
} else {
  console.log('[PRODUCTION DEBUG] Skipping heavy startup imports on /app-form');
}

console.log('[PRODUCTION DEBUG] Boot: starting app render');
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('[PRODUCTION DEBUG] Boot error: Root element not found');
  throw new Error("Root element not found");
}

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  console.error('[PRODUCTION DEBUG] Uncaught error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('[PRODUCTION DEBUG] Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

try {
  console.log('[PRODUCTION DEBUG] Creating root and rendering App...');
  createRoot(rootElement).render(<App />);
  console.log('[PRODUCTION DEBUG] Boot: app render scheduled successfully');
} catch (error) {
  console.error('[PRODUCTION DEBUG] Fatal error during app initialization:', error);
  throw error;
}
